// extracted by mini-css-extract-plugin
export default {"card":"H0-z","carouselContainer":"I0-z","carouselContent":"J0-z"};